import React from 'react';
import { combineReducers, createStore } from 'redux';
import mapReducer from '../map/features/map/reducer';
import kretsReducer from '../catalog/krets-reducer';
import { organizersReducer } from '../service/organizers';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import PortAndWaterwayListContainer, { PortAndWaterwayListContainerProps } from './features/krets/containers/port-and-waterway-list-container';
import { createRoot } from 'react-dom/client';

export default function initPortAndWaterwayList(elementOrId: HTMLElement | string, props: PortAndWaterwayListContainerProps): void {
  console.info('loading port and waterway list page');
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  const store = createStore(
    combineReducers({
      map: mapReducer,
      selectedKrets: kretsReducer,
      organizers: organizersReducer,
    })
  );
  const root = createRoot(element);
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <PortAndWaterwayListContainer {...props} />
      </BrowserRouter>
    </Provider>
  );
}
